"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = listen;
exports.listenOnce = listenOnce;
exports.unlistenByKey = unlistenByKey;

var _obj = require("./obj.js");

/**
 * @module ol/events
 */

/**
 * Key to use with {@link module:ol/Observable.unByKey}.
 * @typedef {Object} EventsKey
 * @property {ListenerFunction} listener Listener.
 * @property {import("./events/Target.js").EventTargetLike} target Target.
 * @property {string} type Type.
 * @api
 */

/**
 * Listener function. This function is called with an event object as argument.
 * When the function returns `false`, event propagation will stop.
 *
 * @typedef {function((Event|import("./events/Event.js").default)): (void|boolean)} ListenerFunction
 * @api
 */

/**
 * @typedef {Object} ListenerObject
 * @property {ListenerFunction} handleEvent HandleEvent listener function.
 */

/**
 * @typedef {ListenerFunction|ListenerObject} Listener
 */

/**
 * Registers an event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` to a `this` object, and returns
 * a key for use with {@link module:ol/events.unlistenByKey}.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [opt_this] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @param {boolean} [opt_once] If true, add the listener as one-off listener.
 * @return {EventsKey} Unique key for the listener.
 */
function listen(target, type, _listener, opt_this, opt_once) {
  if (opt_this && opt_this !== target) {
    _listener = _listener.bind(opt_this);
  }

  if (opt_once) {
    var originalListener_1 = _listener;

    _listener = function listener() {
      target.removeEventListener(type, _listener);
      originalListener_1.apply(this, arguments);
    };
  }

  var eventsKey = {
    target: target,
    type: type,
    listener: _listener
  };
  target.addEventListener(type, _listener);
  return eventsKey;
}
/**
 * Registers a one-off event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` as self-unregistering listener
 * to a `this` object, and returns a key for use with
 * {@link module:ol/events.unlistenByKey} in case the listener needs to be
 * unregistered before it is called.
 *
 * When {@link module:ol/events.listen} is called with the same arguments after this
 * function, the self-unregistering listener will be turned into a permanent
 * listener.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [opt_this] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @return {EventsKey} Key for unlistenByKey.
 */


function listenOnce(target, type, listener, opt_this) {
  return listen(target, type, listener, opt_this, true);
}
/**
 * Unregisters event listeners on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * The argument passed to this function is the key returned from
 * {@link module:ol/events.listen} or {@link module:ol/events.listenOnce}.
 *
 * @param {EventsKey} key The key.
 */


function unlistenByKey(key) {
  if (key && key.target) {
    key.target.removeEventListener(key.type, key.listener);
    (0, _obj.clear)(key);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7O0FBSEE7Ozs7QUFLQTs7Ozs7Ozs7O0FBU0E7Ozs7Ozs7O0FBUUE7Ozs7O0FBS0E7Ozs7QUFJQTs7Ozs7Ozs7Ozs7Ozs7O0FBZU0sU0FBVUEsTUFBVixDQUFpQkMsTUFBakIsRUFBeUJDLElBQXpCLEVBQStCQyxTQUEvQixFQUF5Q0MsUUFBekMsRUFBbURDLFFBQW5ELEVBQTJEO0VBQy9ELElBQUlELFFBQVEsSUFBSUEsUUFBUSxLQUFLSCxNQUE3QixFQUFxQztJQUNuQ0UsU0FBUSxHQUFHQSxTQUFRLENBQUNHLElBQVQsQ0FBY0YsUUFBZCxDQUFYO0VBQ0Q7O0VBQ0QsSUFBSUMsUUFBSixFQUFjO0lBQ1osSUFBTUUsa0JBQWdCLEdBQUdKLFNBQXpCOztJQUNBQSxTQUFRLEdBQUc7TUFDVEYsTUFBTSxDQUFDTyxtQkFBUCxDQUEyQk4sSUFBM0IsRUFBaUNDLFNBQWpDO01BQ0FJLGtCQUFnQixDQUFDRSxLQUFqQixDQUF1QixJQUF2QixFQUE2QkMsU0FBN0I7SUFDRCxDQUhEO0VBSUQ7O0VBQ0QsSUFBTUMsU0FBUyxHQUFHO0lBQ2hCVixNQUFNLEVBQUVBLE1BRFE7SUFFaEJDLElBQUksRUFBRUEsSUFGVTtJQUdoQkMsUUFBUSxFQUFFQTtFQUhNLENBQWxCO0VBS0FGLE1BQU0sQ0FBQ1csZ0JBQVAsQ0FBd0JWLElBQXhCLEVBQThCQyxTQUE5QjtFQUNBLE9BQU9RLFNBQVA7QUFDRDtBQUVEOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBb0JNLFNBQVVFLFVBQVYsQ0FBcUJaLE1BQXJCLEVBQTZCQyxJQUE3QixFQUFtQ0MsUUFBbkMsRUFBNkNDLFFBQTdDLEVBQXFEO0VBQ3pELE9BQU9KLE1BQU0sQ0FBQ0MsTUFBRCxFQUFTQyxJQUFULEVBQWVDLFFBQWYsRUFBeUJDLFFBQXpCLEVBQW1DLElBQW5DLENBQWI7QUFDRDtBQUVEOzs7Ozs7Ozs7OztBQVNNLFNBQVVVLGFBQVYsQ0FBd0JDLEdBQXhCLEVBQTJCO0VBQy9CLElBQUlBLEdBQUcsSUFBSUEsR0FBRyxDQUFDZCxNQUFmLEVBQXVCO0lBQ3JCYyxHQUFHLENBQUNkLE1BQUosQ0FBV08sbUJBQVgsQ0FBK0JPLEdBQUcsQ0FBQ2IsSUFBbkMsRUFBeUNhLEdBQUcsQ0FBQ1osUUFBN0M7SUFDQSxnQkFBTVksR0FBTjtFQUNEO0FBQ0YiLCJuYW1lcyI6WyJsaXN0ZW4iLCJ0YXJnZXQiLCJ0eXBlIiwibGlzdGVuZXIiLCJvcHRfdGhpcyIsIm9wdF9vbmNlIiwiYmluZCIsIm9yaWdpbmFsTGlzdGVuZXJfMSIsInJlbW92ZUV2ZW50TGlzdGVuZXIiLCJhcHBseSIsImFyZ3VtZW50cyIsImV2ZW50c0tleSIsImFkZEV2ZW50TGlzdGVuZXIiLCJsaXN0ZW5PbmNlIiwidW5saXN0ZW5CeUtleSIsImtleSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvZXZlbnRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19